module.exports = "<div class=\"portlet-area\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <ea-message-create-portlet></ea-message-create-portlet>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaMessage/eaMessageOutbox/eaMessageCreatePage/eaMessageCreatePage.tpl.html
// module id = 386
// module chunks = 12